"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableFilter = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
/**
 * TableFilter view component
 * @return {Object}
 */
var TableFilter = function TableFilter(_ref) {
  var className = _ref.className,
    autoWidth = _ref.autoWidth,
    displayEmpty = _ref.displayEmpty,
    label = _ref.label,
    multiple = _ref.multiple,
    _native = _ref["native"],
    onChange = _ref.onChange,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    open = _ref.open,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    value = _ref.value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'standard' : _ref$variant,
    dataTestId = _ref['data-testid'];
  var inputProps = {
    autoWidth: autoWidth,
    displayEmpty: displayEmpty,
    multiple: multiple,
    "native": _native,
    onChange: onChange,
    onClose: onClose,
    onOpen: onOpen,
    open: open,
    value: value,
    variant: variant,
    disabled: !options,
    'data-testid': dataTestId
  };
  return /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, {
    htmlFor: "charger-model"
  }, label), /*#__PURE__*/_react["default"].createElement(_core.Select, inputProps, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      value: option.value,
      key: option.value
    }, option.label);
  })));
};
exports.TableFilter = TableFilter;